<script>
  import { onMount } from 'svelte';

  export let component;
  export let props = {};

  let Component = null;
  let loading = true;
  let error = null;

  onMount(async () => {
    try {
      const module = await component();
      Component = module.default;
      loading = false;
    } catch (err) {
      console.error('Failed to load component:', err);
      error = err;
      loading = false;
    }
  });
</script>

{#if loading}
  <!-- Loading state with brand colors -->
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-50 to-white">
    <div class="text-center">
      <div class="w-16 h-16 rounded-full border-4 border-brand-200 border-t-brand-600 animate-spin mx-auto mb-4"></div>
      <p class="text-slate-600 font-medium">Loading...</p>
    </div>
  </div>
{:else if error}
  <!-- Error state -->
  <div class="min-h-screen flex items-center justify-center bg-white">
    <div class="text-center max-w-md mx-auto p-8">
      <div class="w-16 h-16 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-slate-900 mb-2">Failed to Load</h2>
      <p class="text-slate-600 mb-6">Please refresh the page to try again.</p>
      <button
        class="btn-primary"
        on:click={() => window.location.reload()}
      >
        Refresh Page
      </button>
    </div>
  </div>
{:else if Component}
  <svelte:component this={Component} {...props} />
{/if}
